// extracted by mini-css-extract-plugin
export default {"title":"ef064b54925b","container":"df826ca5aabe"};